import { useCallback, useState } from 'react';
import { Box, Tab, focusOutlineStyles } from '@lingoda/ui';
import type { TabValue } from '@lingoda/router';
import { styled } from '@lingoda/ui/theme';
import { HeaderAvatar } from '../HeaderAvatar';
import { Menu } from '../MenuComponents';
import { UserMenuItems } from './UserMenuItems';

interface UserMenuProps {
    value: TabValue;
}

export const UserMenu = ({ value }: UserMenuProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
        // blur the element to prevent leftover border after click on nav item
        event.currentTarget.blur();
    };

    const handleClose = useCallback(() => {
        setAnchorEl(null);
    }, [setAnchorEl]);

    return (
        <>
            <UserMenuTab
                disableRipple
                onClick={handleClick}
                label={
                    <TabButton aria-controls="user-menu" aria-haspopup="true">
                        <HeaderAvatar />
                    </TabButton>
                }
                value={value}
            />
            <Menu
                id="user-menu"
                anchorEl={anchorEl}
                disableAutoFocus
                keepMounted
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus={false}
                open={!!anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <UserMenuItems onClose={handleClose} />
            </Menu>
        </>
    );
};

const UserMenuTab = styled(Tab)(({ theme }) => ({
    minWidth: 0,
    opacity: 1,
    padding: 0,

    '&:not(:active):focus .MuiAvatar-root': focusOutlineStyles(theme),
}));

const TabButton = styled(Box)(({ theme }) => ({
    fontWeight: 'bold',
    minHeight: 'auto',
    display: 'flex',
    padding: 0,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
}));
